<div class="btn-group" dropdown #dropdown="bs-dropdown" [autoClose]="true">
  <button id="button-basic" type="button"
    class="btn custom-button-small-secondary dropdown-button"
    dropdownToggle
    aria-controls="dropdown-basic"
    aria-haspopup="true" attr.aria-label="{{ userName$ | async }} press enter or click to access menu items."  >
    <div class="mobile-only f-row">
      <app-icon icon="user" class="small-icon" [ngClass]="{ 'white' : dropdown.isOpen }"></app-icon>
    </div>
    <div class="desktop-only f-row">
      <span class="user-name-text">{{ userName$ | async }}</span>
      <app-icon icon="chevron-down" class="chevron-down" [ngClass]="{ 'white' : dropdown.isOpen }"></app-icon>
    </div>
  </button>
  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
    <li class="menuitem mobile-only" id="credit-progress">
      <button class="custom-button-small-secondary" [routerLink]="['/', 'audit']">
        <div class="dropdown-item" [routerLink]="['/', 'audit']">
          <app-icon icon="pie-chart" class="x-small-icon"></app-icon>
          <span class="progress-text">{{ creditProgressText }}</span>
        </div>
      </button>
    </li>
    @if (canImpersonate$ | async) {
      <li role="menuitem" aria-label="Impersonate">
        <div class="dropdown-item"  (click)="openModal()" (keydown.enter)="openModal()" tabindex="0">Impersonate</div>
      </li>
    }
    @if (isAdmin$ | async) {
      <li role="menuitem" aria-label="Admin Dashboard">
        <a class="dropdown-item"  [routerLink]="['/', 'admin']">Admin Dashboard</a>
      </li>
    }
    @if (isSupervisor$ | async) {
      <li role="menuitem" aria-label="Supervisor Dashboard">
        <a class="dropdown-item" [routerLink]="['/', 'supervisor']">Supervisor Dashboard</a>
      </li>
    }
    <!--TODO: This is temporarily commented out until either a toggle is added or LU Serve tells us to turn it back on.-->
    <!--    <li role="menuitem" aria-label="Request CSER 100" *ngIf="needsCSER100$ | async">-->
    <!--      <a class="dropdown-item" href="https://apex.liberty.edu/banprd/f?p=253:14:::NO:RP:FORM_NAME:CSER_100" target="_blank">Request CSER 100</a>-->
  <!--    </li>-->
  @if (shouldShowPastTermRegistrationLink) {
    <li role="menuitem" aria-label="Past Term Registration">
      <a class="dropdown-item" [routerLink]="['/', 'past-term-registration']">Past Term Registration</a>
    </li>
  }
  @if (isAdmin$ | async) {
    <li class="divider dropdown-divider"></li>
  }
  <li role="menuitem" aria-label="logout" >
    <div class="dropdown-item" (click)="logOut()" (keydown.enter)="logOut()" tabindex="0">Log Out</div>
  </li>
</ul>
</div>
@if (modalOpen) {
  <app-impersonate-modal (closeModal)="onModalClose()"></app-impersonate-modal>
}
